
function dateRule(value) {
    return () => {
        if(value) {
            const now = new Date();
            const d = new Date(value);
            now.setHours(0, 0, 0, 0);
            d.setHours(0, 0, 0, 0);
            if(d > now) {
                return "La date ne peut être postérieure à la date du jour"
            }
        }
        return true;
    };
}

function requiredRule(libelle) {
    return f => !!f || libelle || "le champ est obligatoire";
}

function mapper(e) {
    return e.defaultMessage;
}

function serverRule(field) {
    return () => {
        const validation = this.validation;
        if (validation && !validation.disabled) {
            const error = validation.fields[field];
            if (error) {
                return error.map(mapper).join(", ");
            }
        }
        return true;
    };
}

export default function makeRules(options = {}) {
    const { inject = true } = options;

    const out = {
        methods: {
            dateRule,
            requiredRule,
            serverRule
        },
    };

    if (inject) {
        out.inject = ["validation"];
    }


    return out;
}

